<div class="flex flex-col justify-center items-center mt-4" *transloco="let t; read: 'login_register'">

  <psc-section-title
    [title]="t('welcome_back')"
    [subtitle]="t('enter_data')"
  ></psc-section-title>
  <form [formGroup]="formGroup" class="flex flex-col w-[90%] md:w-1/2 xl:w-1/4 md:shrink-0"
        (keydown.enter)="onSubmit()">
    <psc-input type="email"
               formControlName="email"
               [label]="t('email.title')"
               [required]="true"></psc-input>

    <psc-input type="password"
               formControlName="password"
               [label]="t('password.title')"
               [required]="true"></psc-input>

    <div class="text-red-700" *ngIf="formHasError">{{t('invalid_data')}}</div>

    <div>
      <a class="text-color-sun-yellow" routerLink="forgot-password-request">{{t('forgot_password_login')}}</a>
    </div>

    <psc-button class="pt-6 pb-4"
                [label]="t('login.title')"
                (buttonClicked)="onSubmit()"
                [disabled]="!formGroup.valid"
                type="primary-blue-2"></psc-button>
  </form>

  <div>
    {{t('login.no_account')}} <a class="text-color-sun-yellow" routerLink="/register">{{t('here')}}</a>
  </div>
</div>
